// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__mp8fg","additionalInfo":"AgreementModal_additionalInfo__1YF9U"};